module.exports = __webpack_public_path__ + "ptc_nakagawa_O1.009877d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_O1.jpg
// module id = YDtQ
// module chunks = 0